// Copyright (c) Docugami, Inc. All rights reserved.

import { addEntryWithInstancesThunk } from "components/reports/reportsActions";
import { createSelectLabelId } from "store/dgml/dgmlSelectors";
import { createSelectReportLabelIds, selectReportId } from "store/reports/selectors";
import { useAppDispatch, useAppSelector } from "./redux";

const selectReportLabelIds = createSelectReportLabelIds();
const selectLabelId = createSelectLabelId();
export function useAddEntryWithInstances(label: string | undefined, docsetId: string, onComplete?: () => void) {
    const reportId = useAppSelector(selectReportId);
    const reportLabelIds = useAppSelector(state => selectReportLabelIds(state));
    const labelId = useAppSelector(state => selectLabelId(state, docsetId, label ?? ''));

    const canAddEntry = !!labelId && !reportLabelIds.includes(labelId);

    const dispatch = useAppDispatch();

    async function addToReport(documentId: string, spanIds: string[]) {
        await dispatch(addEntryWithInstancesThunk(reportId, {
            folderId: documentId,
            label: label ?? '',
            spanIds: spanIds
        }))

        onComplete?.();
    }

    return {
        canAddEntry: canAddEntry,
        addEntry: addToReport
    }
}